var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudSaved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.3602 6.30078C10.4302 6.09078 10.5002 5.88078 10.5002 5.60078C10.5002 4.06078 9.2402 2.80078 7.7002 2.80078C6.6502 2.80078 5.6702 3.43078 5.2502 4.34078C5.0402 4.27078 4.7602 4.20078 4.5502 4.20078C3.5702 4.20078 2.8002 4.97078 2.8002 5.95078C2.8002 6.09078 2.8002 6.23078 2.8702 6.30078C1.6102 6.51078 0.700195 7.49078 0.700195 8.75078C0.700195 10.0808 1.8202 11.2008 3.1502 11.2008H10.1502C11.4802 11.2008 12.6002 10.0808 12.6002 8.75078C12.6002 7.49078 11.6202 6.44078 10.3602 6.30078ZM5.9502 10.4308L3.7102 8.19078L4.6902 7.21078L5.9502 8.47078L8.6102 5.81078L9.5902 6.79078L5.9502 10.4308Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSaved);
export default __webpack_public_path__ + "static/media/cloud-saved.544e09074ffb70b72292c9522f5ee2ef.svg";
export { ForwardRef as ReactComponent };